import { render, staticRenderFns } from "./LegendSegment.vue?vue&type=template&id=b2e5caa6&"
import script from "./LegendSegment.vue?vue&type=script&lang=js&"
export * from "./LegendSegment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports